import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { usePhoneNumberOptionalSkip } from '../../step-phone-number/hooks/usePhoneNumberOptionalSkip';
import { jsx as _jsx } from "react/jsx-runtime";
export const OptionalPhoneNumberSkipButton = () => {
  const {
    stepKey,
    shouldShowSkipButtonInSidePanel,
    handleClickSkip
  } = usePhoneNumberOptionalSkip();
  return shouldShowSkipButtonInSidePanel && /*#__PURE__*/_jsx(Button, {
    "data-selenium": `${stepKey}_skipLink`,
    marginInlineEnd: "600",
    use: "secondary",
    onClick: handleClickSkip,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "button.skip"
    })
  });
};